export { default } from "./SEO";
